import { useEventCallback } from '@shared/utils/hooks/useEventCallback';
import { AccommodationCombined } from '../components/Accommodations/Accommodation.types';
import { useGoogleInteractableMap } from '@shared/components/JoyInteractableMap/JoyInteractableMap.utils';
import { useJoyInteractableMapContext } from '@shared/components/JoyInteractableMap/JoyInteractableMap.provider';

export const useMapReset = (accommodationsData: AccommodationCombined[], destination: { latitude?: number | null; longitude?: number | null }) => {
  const { map, initialBounds } = useJoyInteractableMapContext();
  const { getCalculatedCenterAndZoom } = useGoogleInteractableMap();

  const resetMapToShowAllMarkers = useEventCallback(() => {
    if (map && getCalculatedCenterAndZoom) {
      const accommodationMarkers = accommodationsData
        .filter(accommodation => accommodation.latitude != null && accommodation.longitude != null)
        .map(accommodation => ({ lat: accommodation.latitude as number, lng: accommodation.longitude as number }));

      const destinationMarker = destination.latitude != null && destination.longitude != null ? [{ lat: destination.latitude, lng: destination.longitude }] : [];

      const markers = [...accommodationMarkers, ...destinationMarker];

      if (markers.length > 0) {
        const { bounds } = getCalculatedCenterAndZoom(markers);

        const targetBounds = initialBounds || bounds;

        if (targetBounds) {
          map.fitBounds(targetBounds);
        }
      }
    }
  }, [map, getCalculatedCenterAndZoom, accommodationsData, destination, initialBounds]);

  return { resetMapToShowAllMarkers };
};
